import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";
import { K } from "./apiServiceI18n";
import {
  buildApiServiceManagerReturnUrl,
  loadWizardReturnContext,
} from "./apiServiceWizardSession";

/**
 * Shown on workbench mapping when user arrived from API Service wizard.
 * Returns to Translate Data step in the creation wizard.
 */
export default function ApiServiceWizardReturnButton() {
  const { t } = useTranslation();
  const returnCtx = loadWizardReturnContext();

  if (!returnCtx) return null;

  const handleReturn = () => {
    window.location.href = buildApiServiceManagerReturnUrl();
  };

  return (
    <Button
      size="small"
      variant="contained"
      color="secondary"
      className="margin-right-4"
      startIcon={<ArrowBackIcon />}
      onClick={handleReturn}
      aria-label={t(K.API_SVC_GO_BACK_WIZARD)}
      sx={{ textTransform: "none" }}
    >
      {t(K.API_SVC_CONTINUE_WIZARD)}
    </Button>
  );
}
